import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  showBalances: boolean[];
  displayTotalBalance: boolean;
}

const initialState: InitialState = {
  showBalances: [],
  displayTotalBalance: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setShowBalances: (state, { payload }) => {
      state.showBalances = payload;
    },
    setDisplayTotalBalance: (state, { payload }) => {
      state.displayTotalBalance = payload;
    },
  },
});

export const {
  setShowBalances,
  setDisplayTotalBalance,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
